import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
        <p>@{currentYear} All Rights Reserved. Created and developed by <a href="https://www.twitter.com/0xwebninja">WebNinja</a></p>
    </footer>
  );
}

export default Footer;